import React, { memo, useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../../../../store/root-reducer';
import CallLogsSubHeader from './call-logs-sub-header';
import { purchaseEmailVerificationCreditsRequest as purchaseEmailVerificationCreditsRequestAction } from '../../../../../settings/components/billing-subscription/extra-actions';
import { getPostLoadMetaRequest } from '../../../../../home/extra-actions';

interface IProps {
  search: string;
  onSearchChange: (value: string) => void;
  onFilterClick?: () => void;
  activeFilterCount?: number;
  showAddNewTemplate?: boolean;
  handleAddNewTemplate?: () => void;
  showFilter?: boolean;
  searchPlaceholder?: string;
}

type PurchaseEmailVerificationCreditsPayload = Parameters<
  typeof purchaseEmailVerificationCreditsRequestAction
>[0];

const CallLogsSubHeaderContainer: React.FC<IProps> = memo(
  ({
    search,
    onSearchChange,
    onFilterClick,
    activeFilterCount,
    showAddNewTemplate,
    handleAddNewTemplate,
    showFilter = true,
    searchPlaceholder,
  }) => {
    const dispatch = useDispatch();

    const currentPlanName = useSelector(
      (state: RootState) => state.home?.subscription?.planName || '',
    );

    const getEmailVerificationPlanResponse = useSelector(
      (state: RootState) =>
        state.billingAndSubscription?.getEmailVerificationPlanResponse,
    );

    const sendPurchaseEmailVerificationCreditsRequestStatus = useSelector(
      (state: RootState) =>
        state.billingAndSubscription?.purchaseEmailVerificationCreditsRequest
          ?.status,
    );

    const currentCallManagementState = useSelector(
      (state: RootState) => state?.dialer?.currentCallManagementState,
    );
    const getPostLoadMetaResponse = useSelector(
      (state: RootState) => state?.home?.getPostLoadMetaResponse,
    );

    const purchaseEmailVerificationCreditsRequest = useCallback(
      (payload: PurchaseEmailVerificationCreditsPayload) => {
        dispatch(purchaseEmailVerificationCreditsRequestAction(payload));
      },
      [dispatch],
    );

    useEffect(() => {
      dispatch(getPostLoadMetaRequest());
    }, [dispatch]);

    return (
      <CallLogsSubHeader
        showFilter={showFilter}
        search={search}
        onSearchChange={onSearchChange}
        onFilterClick={onFilterClick}
        activeFilterCount={activeFilterCount}
        currentPlanName={currentPlanName}
        getEmailVerificationPlanResponse={getEmailVerificationPlanResponse}
        sendPurchaseEmailVerificationCreditsRequestStatus={
          sendPurchaseEmailVerificationCreditsRequestStatus
        }
        purchaseEmailVerificationCreditsRequest={
          purchaseEmailVerificationCreditsRequest
        }
        showAddNewTemplate={showAddNewTemplate}
        handleAddNewTemplate={handleAddNewTemplate}
        currentCallManagementState={currentCallManagementState}
        getPostLoadMetaResponse={getPostLoadMetaResponse}
        searchPlaceholder={searchPlaceholder}
      />
    );
  },
);

export default CallLogsSubHeaderContainer;
